module.exports = __webpack_public_path__ + "assets/img/baohanmsg.6d49a5a2.png";